import { useState } from "react";
import { ToastItem } from "../types/toast";

export default function useToasts(initialState: []) {
  const [toasts, setToasts] = useState<Array<ToastItem>>(initialState);

  return { toasts, setToasts };
}
